import React, { useEffect } from "react";
import {
  Grid,
  Box, Skeleton
} from "@mui/material";
import StyledSection from "../../../common/StyledSection";
import { ContainedButton, TextButton } from "../../../common/StyledButtons";
import { withRouter } from "react-router";

const MY_RESOURCES = [
  {
    name: 'Schedule a Meeting',
    description: `Want to chat tech, brainstorm future business ideas, or give your website a fresh polish? Book a time with BCK Consulting! We’re here to help you reach your goals and make sure your online presence shines.`,
    img_url: 'https://s3.us-east-2.amazonaws.com/docs.consultwithkyle.com/assets/bck-schedule.webp',
    action_1: {
      url: 'https://consultwithkyle.com/appointments',
      text: 'Book Time Now'
    }
  },
  {
    name: 'Start a New Project',
    description: `Ready to kick off a new project? Whether it’s adding a new page or launching an entire business, BCK Consulting is here to listen and help you succeed. Let’s turn your vision into reality!`,
    img_url: 'https://s3.us-east-2.amazonaws.com/docs.consultwithkyle.com/assets/bck-start-new.webp',
    action_1: {
      url: 'https://consultwithkyle.com/appointments',
      text: 'Get Started'
    }
  },
  {
    name: 'Explore Resources',
    description: `Excited to start something new? Whether it’s adding a page or launching your dream business, BCK Consulting is here to listen and support you every step of the way. Let’s make your vision a reality!`,
    img_url: 'https://s3.us-east-2.amazonaws.com/docs.consultwithkyle.com/assets/bck-resources.webp',
    action_1: {
      url: 'https://consultwithkyle.com/resources',
      text: 'Explore & Learn More'
    }
  }
]


const ResourcesCard = ({ history, siteId }) => {

  const renderResourcesCards = () => MY_RESOURCES.map((tool) => (
    <StyledSection
      title={tool.name}
      image={tool.img_url}
    >
      <p>{tool.description}</p>
      
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
        <ContainedButton
          sx={{ padding: '8px 16px 8px 16px' }}
          onClick={() => window.open(tool.action_1.url, '_blank').focus()}
        >{tool.action_1.text}</ContainedButton>
      </Box>
    </StyledSection>
  ))

  return renderResourcesCards();
}

export default withRouter(ResourcesCard);
